import { render } from "./confirmEditLot.vue?vue&type=template&id=2db066dc&scoped=true"
import script from "./confirmEditLot.vue?vue&type=script&lang=js"
export * from "./confirmEditLot.vue?vue&type=script&lang=js"

import "./confirmEditLot.vue?vue&type=style&index=0&id=2db066dc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db066dc"]])

export default __exports__